import { Component, Input, OnInit } from '@angular/core';
import { ActivityEditorBaseComponent } from '../../activity-editor-base/activity-editor-base.component';
import { OptionalCompleteActivity } from 'src/app/models/activities';
import { UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-optional-complete-activity-editor',
  templateUrl: './optional-complete-activity-editor.component.html',
  styleUrl: './optional-complete-activity-editor.component.css',
  standalone: false
})
export class OptionalCompleteActivityEditorComponent extends ActivityEditorBaseComponent {
  @Input() activity: OptionalCompleteActivity;
}
